import React, { useEffect, useState } from "react";
import { Col, Row, Typography, Breadcrumb, Input, Checkbox, Button } from "antd";
import { RightOutlined, SearchOutlined } from "@ant-design/icons";
import "./MyMatches.css";
import { useDispatch, useSelector } from "react-redux";
import { getSkillMatches, isModalVisibleAuth } from "../../redux/actions";
import BottomLine from "../../components/BottomLine/BottomLine";
import { useLocation } from "react-router-dom";
import Loader from "../../components/Loading/Loader";
import GigsCard from "./components/cardsContainer/GigCard";
import noData from "../../assets/img/cuate@2x.png";
import history from "../../routes/history";
import PlaceBidModal from "../../components/PlaceBidModal/PlaceBidModal";
import moment from "moment";
import MatchesGigsCard from "./components/cardsContainer/MatchedGigCard";

function MyMatches(props) {
  const { Text } = Typography;
  const dispatch = useDispatch();
  const location = useLocation();
  var jobId = location.pathname?.split("findmatches/")[1]?.split("/")[0];
  const token = useSelector((state) => state.authReducer.user.authToken);
  const [searchtext, setSearch] = useState(false);
  const [myMatches, setMyMatches] = useState([]);
  const [checkAllCandidate, setcheckAllCandidate] = React.useState(false);
  const [skillSetwithIDsAll, setSkillSetwithIDsAll] = useState([]);
  const [checkedBoxes, setCheckedBoxes] = useState([]);
  const [skillSetwithIDs, setSkillSetwithIDs] = useState([]);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [checkedCandidates, setCheckedCandidates] = useState([]);
  const [candidateList, setcandidateList] = useState([]);
  const [overflowOtherMatches, setOverflowOtherMatches] = useState();
  const [placebidModal, setplacebidModal] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );



  const skillset = useSelector((state) => state.getMatchesReducer.skillset);
  const matches = useSelector((state) => state.MatchedSkillReducer.matched);
  const loading = useSelector((state) => state.MatchedSkillReducer.loading);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [])

  useEffect(()=>{
      let tempCandidates = [];
      for(let i=0; i < selectedCandidates?.length; i++){
        matches?.other_matches?.map((item)=>{
          if(item?.skill_listing?.SkillListingId == selectedCandidates[i]){
            tempCandidates.push(item)
          }
        })
      }

      setCheckedCandidates(tempCandidates)
      setcandidateList(tempCandidates)
  },[selectedCandidates,skillSetwithIDsAll])

  useEffect(() => {
    dispatch(getSkillMatches(location?.state?.id ?? jobId));
  }, []);
  
  useEffect(() => {
    var candidateslistArray = [];
    for (var i = 0; i < checkedCandidates.length; ++i) {
      candidateslistArray.push({
        id: checkedCandidates[i]?.skill_listing?.SkillListingId,
        img: checkedCandidates[i]?.user?.Accounts?.PictureUrl,
        AccountId: checkedCandidates[i]?.user?.Accounts?.AccountId,
        name:
        checkedCandidates[i]?.user?.Accounts.FirstName +
            " " +
            checkedCandidates[i]?.user?.Accounts.LastName ?? "Candidate name",
        experience:
        checkedCandidates[i]?.user?.ExperienceLevelName ? 
        checkedCandidates[i]?.user?.ExperienceLevelName :
        checkedCandidates[i]?.user?.Accounts?.ExperienceLevels?.ExperienceLevelName ? 
        checkedCandidates[i]?.user?.Accounts?.ExperienceLevels?.ExperienceLevelName : "N/A",
        title: checkedCandidates[i].skill_listing?.Title,
        desired_rate: checkedCandidates[i].skill_listing?.MinimumBid
          ?.$numberDecimal
          ? Math.floor(
            checkedCandidates[i].skill_listing?.MinimumBid?.$numberDecimal
            )
          : checkedCandidates[i].skill_listing?.MinimumBid,
        bidType: checkedCandidates[i]?.skill_listing?.BudgetTypes
          ?.BudgetTypeName
          ? checkedCandidates[i]?.skill_listing?.BudgetTypes?.BudgetTypeName
          : checkedCandidates[i].skill_listing?.MinimumBidType,
        profileType: checkedCandidates[i]?.user?.Professions?.ProfessionCode,
        lastActive:
        checkedCandidates[i].user?.Accounts?.LastSuccessfulLoginDate != null
            ? moment(
              checkedCandidates[i].user?.Accounts?.LastSuccessfulLoginDate
              ).fromNow() : checkedCandidates[i].user?.LastSuccessfulLoginDate ? moment(
                checkedCandidates[i].user?.LastSuccessfulLoginDate
                ).fromNow()
            : "N/A",
      });
    }
    setcandidateList(candidateslistArray);
  }, [checkedCandidates]);
  

  const placeABidFunction = () => {
    
    setplacebidModal(true);
    if (token !== null) {
      setplacebidModal(true);
    } else {
      if (windowDimensions.width < 768) {
        history.push({
          pathname: "/login",
        });
      } else {
        dispatch(isModalVisibleAuth(true));
      }
    }
    
  };


  const getSearchText = (e) => {
    setCheckedBoxes([]);
    setSkillSetwithIDs([]);
    setSkillSetwithIDsAll([]);
    setSelectedCandidates([]);
    setcheckAllCandidate(false);
    setSkillSetwithIDsAll([]);
    setSearch(e.target.value);
    if (e.target.value.length > 0) {
      var search = matches?.other_matches?.filter((item) => {
        if (item?.user?.Accounts?.FirstName) {
          if (
            item?.skill_listing?.Title.toLowerCase().includes(
              e.target.value.toLowerCase()
            ) ||
            item?.user?.Accounts?.FirstName.toLowerCase().includes(
              e.target.value.toLowerCase()
            ) ||
            item?.user?.Accounts?.LastName.toLowerCase().includes(
              e.target.value.toLowerCase()
            ) ||
            (
              item?.user?.Accounts?.FirstName.toLowerCase() +
              " " +
              item?.user?.Accounts?.LastName.toLowerCase()
            ).includes(e.target.value.toLowerCase())
          ) {
            return item;
          }
        }
      });
      setMyMatches(search);
    } else {
      setMyMatches(
        matches?.other_matches?.length ? matches?.other_matches : []
      );
    }
  };
  useEffect(() => {
    if (matches?.other_matches) {
      setMyMatches(matches.other_matches);
    }
  }, [matches]);

  useEffect(() => {
    var skillSetAllInitialData = [];
    var skillsCardsAll = {
      ids: [],
      checked: false,
      total_ids: searchtext?.length,
    };
    skillSetAllInitialData.push(skillsCardsAll);

    setSkillSetwithIDsAll(skillSetAllInitialData[0]);
  }, [searchtext]);

  useEffect(()=>{
    if(candidateList?.length<checkedCandidates?.length){
      setcheckAllCandidate(false);
    }
  },[candidateList])
  function onCheckAllChange(e) {
    if (searchtext) {
      var ids = [];

      if (checkAllCandidate) {
        var skillsCardsAll = {
          ids: ids,
            // .filter((res) => {
            //   return res.isBidPlaced == false;
            // })
            // .slice(0, 5),
          checked: false,
          total_ids: searchtext?.length,
        };

        var candidatesArrayIds = [];
        var candidatesArrays = [];

        // Setting selectedCandidates after all check

        // selectedCandidates.map((skillListingObj) => {
        //   if (
        //     searchtext?.find(
        //       (skillListingObject) =>
        //         skillListingObject?.skill_listing?.SkillListingId ==
        //         skillListingObj.skill_listing?.SkillListingId
        //     )
        //   ) {
        //   } else {
        //     if (
        //       candidatesArrayIds.includes(
        //         skillListingObj?.skill_listing?.SkillListingId
        //       )
        //     ) {
        //     } else {
        //       candidatesArrayIds.push(
        //         skillListingObj?.skill_listing?.SkillListingId
        //       );
        //       candidatesArrays.push(skillListingObj);
        //     }
        //   }
        // });
        setSelectedCandidates([]);
        setCheckedCandidates([])
      } else {
        for (var i = 0; i < myMatches?.length; i++) {
          ids = [...ids, myMatches[i]?.skill_listing?.SkillListingId];
        }
        
        // Setting selectedCandidates after all uncheck
        
        var testt = selectedCandidates;
        for (var i = 0; i < ids.length; i++) {
          if (!ids[i].isBidPlaced) {
            testt.push(ids[i]);
            // setSelectedCandidates(testt.slice(0, 10));
            setSelectedCandidates(testt);
          }
          
        }

        var skillsCardsAll = {
          // ids: ids?.slice(0, 10),
          ids: ids,
            // .filter((res) => {
            //   return res.isBidPlaced == false;
            // })
            // .slice(0, 5),
          checked: true,
          total_ids: searchtext?.length,
        };
      }
      setSkillSetwithIDsAll(skillsCardsAll);
      setcheckAllCandidate(!checkAllCandidate);
    } else {

      var ids = [];

      if (checkAllCandidate) {

        var skillsCardsAll = {
          ids: ids.filter((res) => {
            return res.isBidPlaced == false;
          }),
          checked: false,
          total_ids: myMatches?.length,
        };

        var candidatesArrayIds = [];
        var candidatesArrays = [];

        // selectedCandidates.map((skillListingObj) => {
        //   if (
        //     matches?.allskills_matches?.matches?.find(
        //       (skillListingObject) =>
        //         skillListingObject?.skill_listing?.SkillListingId ==
        //         skillListingObj?.skill_listing?.SkillListingId
        //     )
        //   ) {
        //   } else {
        //     if (
        //       candidatesArrayIds.includes(
        //         skillListingObj?.skill_listing?.SkillListingId
        //       )
        //     ) {
        //     } else {
        //       candidatesArrayIds.push(
        //         skillListingObj?.skill_listing?.SkillListingId
        //       );
        //       candidatesArrays.push(skillListingObj);
        //     }
        //   }
        // });
  
        setSelectedCandidates([]);
        setCheckedCandidates([]);
      } else {

        for (var i = 0; i < myMatches?.length; i++) {
          ids = [...ids, myMatches[i]?.skill_listing?.SkillListingId];
        }

        var testt = [];
        for (var i = 0; i < ids.length; i++) {
          if (!ids[i].isBidPlaced) {
            testt.push(ids[i]);
            // setSelectedCandidates(testt.slice(0, 10));
            setSelectedCandidates(testt);
          }
        }

        var skillsCardsAll = {
          // ids: ids?.slice(0, 10),
          ids: ids,
            // .filter((res) => {
            //   return res.isBidPlaced == false;
            // })
            // .slice(0, 5),
          checked: true,
          total_ids: myMatches?.length,
        };
      }

      setSkillSetwithIDsAll(skillsCardsAll);
      setcheckAllCandidate(!checkAllCandidate);
    }
  }

  const cancelBids = () => {
    setcheckAllCandidate(false);
    setSelectedCandidates([]);
    setCheckedCandidates([])
    // setOverflowAllMatches(false);
    setCheckedBoxes([]);

    var skillSetAllInitialData = [];
    var skillsCardsAll = {
      ids: [],
      checked: false,
      total_ids: matches?.allskills_matches?.matches?.length,
    };
    skillSetAllInitialData.push(skillsCardsAll);
    setSkillSetwithIDsAll(skillSetAllInitialData[0]);

    var skillSetInitialData = [];
    var overFlowArrayInitialData = [];
    for (var i = 0; i < skillset?.length; i++) {
      var skillsCards = {
        index: i,
        ids: [],
        checked: false,
        total_ids: skillset[i][1]?.length,
      };

      var overFlowArray = {
        index: i,
        overflow: false,
        cardsLength: skillset[i][1]?.length,
      };
      overFlowArrayInitialData.push(overFlowArray);
      skillSetInitialData.push(skillsCards);
    }

    setOverflowOtherMatches(overFlowArrayInitialData);
    setSkillSetwithIDs(skillSetInitialData);
  };

  const placeBidModalVisisblityHandler = (value) => {
    setplacebidModal(value);
    // const temp = selectedCandidates?.filter(number => {
    //   return myMatches.some(object => object.SkillListingId === number);
    // });
    // if(temp.length === 0){
    //   console.log('okok');
    //   setSelectedCandidates([]);
    //   // setcandidateList([]);
    // }
  };


useEffect(() => {
 if (selectedCandidates?.length == 0) {
      setplacebidModal(false);
    }
},[selectedCandidates])


  return (
    <Col xs={24} lg={24} className="main-parent">
    



    <PlaceBidModal
      fromMatches = {true}
      jobdetails = {location?.state?.jobdetails}
      jobId={props.job_id ?? location?.state?.id ?? jobId}
        visible={placebidModal}
        placeBidModalVisisblityHandler={placeBidModalVisisblityHandler}
        selectedCandidates={candidateList}
        setSelectedCandidates={setcandidateList}
        setSkillListingIds={setcandidateList}
        skillListingIds={candidateList}
        setCheckedCandidates={setSelectedCandidates}
        checkedCandidates={selectedCandidates}
        desired_rate={
          selectedCandidates?.length == 1 ? candidateList[0]?.desired_rate : 1
        }
        multiBid={selectedCandidates?.length == 1 ? false : true}
        rate_flag={true}
        frompdetail={true}
      />
      <>
        <BottomLine />
        <div style={{ marginTop: "5px", padding: "5px" }}>
          <Col className="bread-crumbs-div">
            <Breadcrumb separator={<RightOutlined />}>
              <Breadcrumb.Item onClick={history.goBack}>
                <Text className="crumb-text1">
                  {props?.job_title ?? location?.state?.title ?? `Gig title`}{" "}
                </Text>
              </Breadcrumb.Item>
              <Breadcrumb.Item href="">


                 <Text className="crumb-text2">Matches</Text>
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <div className="input-div">
            <Input
              prefix={<SearchOutlined style={{ color: "#7e7e7e" }} />}
              type={"input"}
              placeholder="Search Skill listing, Candidate name"
              onChange={getSearchText}
              allowClear
            />
          </div>
          {loading ? (
            <Loader />
          ) : myMatches?.length ? (
            <>
              {searchtext && searchtext.length != 0 ? (
                <div style={{ padding: "15px 0px" }}>
                  <Checkbox
                    onChange={(e) => onCheckAllChange(e)}
                    checked={checkAllCandidate}
                  />
                  <Text className="select-all-checkbox">
                    {checkAllCandidate
                      ? `Deselect all skill listings`
                      : `Select all skill listings`}
                  </Text>
                </div>
              ) : null}
              {!searchtext ? (
                <div style={{ padding: "15px 0px" }}>
                  <Checkbox
                    onChange={(e) => onCheckAllChange(e)}
                    checked={checkAllCandidate}
                  />
                  <Text className="select-all-checkbox">
                    {checkAllCandidate
                      ? `Deselect all skill listings`
                      : `Select all skill listings`}
                  </Text>
                </div>
              ) : null}
              <div className={"CardsRow"}>
                {myMatches?.map((data, index) => {
                  return (
                    <MatchesGigsCard
                      {...data}
                      key={index}
                      jobdetails={location.state.jobdetails}
                      MinimumBid={
                        (data.skill_listing?.MinimumBid?.$numberDecimal &&
                          Math.floor(
                            data.skill_listing?.MinimumBid?.$numberDecimal
                          )) ??
                        data.skill_listing?.MinimumBid
                      }
                      MinimumBidType={
                        data?.skill_listing?.BudgetTypes?.BudgetTypeName
                          ? data?.skill_listing?.BudgetTypes?.BudgetTypeName
                          : data.skill_listing?.MinimumBidType
                      }
                      ClientRate={
                        (data?.skill_listing?.ClientRate &&
                          data?.skill_listing?.ClientRate?.$numberDecimal) ??
                        data?.skill_listing?.ClientRate?.toFixed(2)
                      }
                      skillTitle={data.skill_listing?.Title}
                      candidateName={`${data?.user?.Accounts?.FirstName}${" "}${
                        data?.user?.Accounts?.LastName
                      }`}
                      LastSuccessfulLoginDate={
                        data?.user?.Accounts?.LastSuccessfulLoginDate
                      }
                      ExperienceLevelName={data?.user?.ExperienceLevelName}
                      PictureUrl={data?.user?.Accounts?.PictureUrl}
                      token={token}
                      _id={data.skill_listing?.SkillListingId}
                      skillListObj={data}
                      selectedCandidates={selectedCandidates}
                      setSelectedCandidates={setSelectedCandidates}
                      jobId={props.job_id ?? location.state?.id ?? jobId}
                      job_title={props.job_title}
                      selectAll={checkAllCandidate}
                      setcheckAllCandidate={setcheckAllCandidate}
                      checkAllDataAll={checkedCandidates}
                      setCheckAllDataAll={setCheckedCandidates}
                      checkAllData={null}
                      setCheckAllData={null}
                      checkedBoxes={null}
                      setCheckedBoxes={null}
                      index={null}
                      isViewed={data?.isViewed}
                      user={data?.user}
                    />
                  );
                })}
              </div>
            </>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop: "15vh",
                overflow: "hidden",
              }}
            >
              <img src={noData} /> <br />
              <div>No matches found</div>
            </div>
          )}
        </div>
        {candidateList.length > 0 && windowDimensions.width >= 800 ? (
              <div className="btn-div">
                <Col xs={24} className="bid-btn-div">
                  <Button className={"cancel-bids-btn"} onClick={cancelBids}>
                    <Text className="cancel-btn-text">Cancel</Text>
                  </Button>
                  <Button
                    className={"multi-bids-btn"}
                    onClick={placeABidFunction}
                  >
                    <Text className="multi-bids-btn-text">
                      Place a bid{" "}
                      {candidateList.length > 0
                        ? `( ${candidateList.length} ${candidateList.length>1? 'Skill listings' : 'Skill listing'} )`
                        : null}
                    </Text>
                  </Button>
                </Col>
              </div>
            ) : (
              checkedCandidates.length > 0 &&
              windowDimensions.width < 800 && (
                <div className="btn-div-sm">
                  <Button
                    className={"multi-bids-btn-sm"}
                    onClick={placeABidFunction}
                  >
                    <Text className="multi-bids-btn-text">
                      Place a bid{" "}
                      {checkedCandidates.length > 0
                        ? "( " +
                        checkedCandidates.length +
                          " Skill Listings )"
                        : null}
                    </Text>
                  </Button>
                  <Button className={"cancel-bids-btn-sm"} onClick={cancelBids}>
                    <Text className="cancel-btn-text">Cancel</Text>
                  </Button>
                </div>
              )
            )}
      </>
    </Col>
  );
}

export default MyMatches;
